<template>
  <section class="Inquiry__result__period__aggregation0015">
    <el-row :gutter="0" class="Inquiry__result__period__aggregationHead">
      <router-link to="/sp/0002" class="Router__To__Destination" tabindex="1">
        <i class="el-icon-close" tabindex="1"></i>
      </router-link>
      <el-col :span="6" class="whiteBg">
        <span class="Inquiry__result__period__aggregationSpan">照会結果－期間集計</span>
      </el-col>
      <el-col :span="12">
        <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <el-row class="Inquiry__result__period__aggregationBody">
      <div>
        <el-form ref="form" :model="form" class="div-result">
          <el-form-item label="集計対象">
            <span>{{ this.$route.params.data.AggregationconditionUser_id}}</span>
          </el-form-item>
          <!-- <el-form-item label="ユーザーID別">
            <span>{{ getFormMethod__mobile }}</span>
          </el-form-item> -->
          <el-form-item label="集計方法">
            <span>{{ getFormPeriod }}</span>
          </el-form-item>
          <el-form-item label="集計期間">
            <span>{{ this.$route.params.data.startDate }}~{{ this.$route.params.data.endDate }}</span>
          </el-form-item>
          <!-- <el-form-item label="集計条件">
            <span>{{ getFormTitle__mobile }}</span>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="data__table">
        <el-table
          :data="getTableResult0015"
          :span-method="arraySpanMethod"
          style="width: 100%"
          
        >
          <el-table-column prop="user_group_name" label="ユーザーグループＩＤ" width=""></el-table-column>
          <el-table-column prop="user_id" label="ユーザーＩＤ" width=""></el-table-column>
          <el-table-column prop="process_date" label="利用年月日" width="150"></el-table-column>
          <el-table-column label="ELNET">
            <el-table-column  label="原文" width="">
              <el-table-column prop="pdf_count" label="表示" width="" class="display__value"></el-table-column>
              <el-table-column prop="print_count" label="印刷" width="" class="printing__value"></el-table-column>
            </el-table-column>
            <el-table-column label="テキスト本文">
              <el-table-column prop="text_disp_count" label="表示" width="" class="display__value"></el-table-column>
              <el-table-column prop="text_print_count" label="印刷" width="" class="printing__value"></el-table-column>
            </el-table-column>
            <el-table-column prop="mc_count" label="小計" width="" class="sub__total"></el-table-column>
          </el-table-column>
          <el-table-column label="日経" width="">
            <el-table-column prop="sc_text_count" label="テキスト" width="" class="text__value"></el-table-column>
            <el-table-column prop="sc_count" label="原文" width="" class="Original__text"></el-table-column>
          </el-table-column>
          <el-table-column prop="count" label="合計" width="" class="total__value"></el-table-column>
        </el-table>
      </div>
      <el-button type="info" plain @click="gofrom0015" class="Return__button">戻る</el-button>
    </el-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import router from "../../router";
//import Common from '../../common/CommonFunc.js';
//import Vue from 'vue';
export default {
  name: "Inquiry__result__period__aggregation0015",
  components: {},
  data() {
    return {
      form: {},
      userId: ""
    };
  },
  methods: {
    //for merging the table coloum as per the req
    arraySpanMethod({ rowIndex, columnIndex }) {
      if (rowIndex === this.getRowCount) {
        if (columnIndex === 0) {
          return [1, 3];
        } else if (columnIndex === 1) {
          return [0, 0];  
        }
        else if (columnIndex === 2) {
          return [0,0];
        }
      }
    },
    gofrom0015() {
this.$LogButtonEvent("0015","Return");
this.$LogMethodIN("0015","gofrom0015");       
      router.push({ name: "sp_0014" });
      this.$LogMethodOut("0015","gofrom0015");
    }
  },
  computed: {
    ...mapGetters("sp_Situation0015", [
      "getTableResult0015",
      "getFormUser",
      "getFormMethod",
      "getFormPeriod",
      "getFormCondition",
      "getFormTitle",
      "getUserGroupId",
      "getRowCount"
    ]),
  ...mapGetters("situation0001", [     
      "getUserId",
      "getContractId",
      "getUserGroupName"
    ])
  },
  mounted() {
    this.userId = this.getUserId;
    //Get table articles during page load
    //this.$store.dispatch('communication0015/login');
    var aggregationPeriod = this.getFormCondition;
    var splitPeriod = aggregationPeriod.split(" ~ ");
    var startDate = splitPeriod[0];
    var endDate = splitPeriod[1];
    console.log(startDate);
    console.log(endDate);
    console.log(aggregationPeriod);
    console.log(splitPeriod);
    
    var articleValues = {
        contract_id: this.getContractId,
        user_id: this.userId,
        //user_group_id: Vue.prototype.$session.get('user_group_id'),
        user_group_name: this.getUserGroupName,
        start_day:this.$route.params.data.startDate,
        end_day:this.$route.params.data.endDate
    };

  
    this.$store.dispatch('sp_Communication0015/getMobileArticleList',articleValues);
    this.$store.commit('sp_Situation0001/setThemeLoadCheck', 0);

  },
  beforeCreate(){
      //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
      //Common.Session.CheckIsMobile("/sp/0015","/0015"); // MobileScreen Path, WebScreen Path
 }
};
</script>

<style scoped>
@import "0015.css";
@import "../../assets/css/customStyle.css";
</style>